<template>
  <div class="tableBox" ref="tableBox">
    <el-table ref="table" :data="datas" :header-cell-style="headStyle" :height="height" @selection-change="change" v-loading="loading">
      <el-table-column v-if="selection" type="selection" width="55" :selectable="selectable" />
      <el-table-column v-if="remove" :render-header="renderHeader" width="55">
        <template v-slot="scope">
          <span class="tableRemoveBtn" @click="removeFn(scope)">-</span>
        </template>
      </el-table-column>
      <template v-for="(item, index) in heads">
        <el-table-column 
          v-if="item.handle" 
          :label="item.label" 
          :key="`head_${index}`"
          :width="item.width ? item.width : null" 
          :align="item.textAlign"
          :min-width="item.minWidth ? item.minWidth : null" 
          :fixed="item.fixed"
          :formatter="item.formatter ? item.formatter : null">
          <template v-slot="scope">
            <slot name="handle" :data="scope.row" :scope="scope" :head="item" :index="scope.$index + 1"></slot>
          </template>
        </el-table-column>
        <el-table-column 
          v-else 
          :key="item.prop" 
          :prop="item.prop" 
          :label="item.label"
          :width="item.width ? item.width : null" 
          :align="item.textAlign"
          :min-width="item.minWidth ? item.minWidth : null" 
          :fixed="item.fixed"
          :formatter="item.formatter ? item.formatter : null">
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    datas: {
      default() {
        return [];
      },
    },
    heads: {
      default() {
        return [];
      },
    },
    selection: {
      default() {
        return false;
      },
    },
    remove: {
      default() {
        return false;
      },
    },
    nowStatus: {
      default() {
        return "启用";
      },
    },
    loading: {
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      headStyle: {
        background: "#F4F5F9",
        color: "#7B8293",
      },
      height: 0,
      timer: null,
    };
  },
  methods: {
    renderHeader(h) {
      return (
        <span class="tableRemoveBtn" onClick={() => this.addFn()}>
          +
        </span>
      );
    },
    addFn() {
      this.$emit("tableAdd");
    },
    removeFn(scope) {
      this.datas.splice(scope.$index, 1);
    },
    change(arr) {
      this.$emit("change", arr);
    },
    selectable(row) {
      return true;
      return row.sbstate != this.nowStatus;
    },
    init() {
      this.$nextTick(() => {
        this.height = this.$refs.tableBox.getBoundingClientRect().height;
        if (!this.height) this.height = 300;
      });
    },
  },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 200);
    window.onresize = this.init;
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
    this.init = null;
    window.onresize = null;
  },
  watch: {
    nowStatus() {
      this.$emit("change");
      this.$refs.table.clearSelection();
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .el-table {
    width: 100%;
    height: 100%;
  }
}

.tableBox {
  width: 100%;
  height: 100%;
}
</style>
